import React from 'react'
import { Typography } from '@material-ui/core'
import { ReactComponent as PinardLogo } from 'assets/icons/pinard-logo.svg'

import { useStyles } from './Footer.style'

const Footer = () => {
  const classes = useStyles()

  return (
    <footer className={classes.footer}>
      <a
        href='https://pinard.com.ar/'
        target='_blank'
        rel='noopener noreferrer'
        className={classes.developmentInfo}>
        <Typography className={classes.developmentText} variant='caption'>
          Desarrollado por
        </Typography>
        <PinardLogo className={classes.pinardLogo} />
      </a>
    </footer>
  )
}

export default Footer
